import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs';
import { NotificationModel, NotificationsService, NotificationTypes } from '../../../shared/services/notifications/notifications.service';
import { CustomerDto } from '../interfaces/customer-dto.interface';
import { CustomerService } from '../services/customer.service';

@Component({
    selector: 'customer-add-component',
    templateUrl: './customer-add.control.html',
    styleUrls: ['./customer-add.control.scss'],
    standalone: false
})
export class AddCustomerComponent {
  isLoading = false;

  constructor(
    private _customerService: CustomerService,
    private _notificationsService: NotificationsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  createCustomer([customerName, data]: [string, CustomerDto]) {
    this.isLoading = true;
    // start form loading

    this._customerService
      .createCustomer(data)
      .pipe(first())
      .subscribe({
        next: (customer: CustomerDto) => {
          const notification: NotificationModel = {
            message: `Successfully created customer: ${customerName}.`,
            action: 'Close',
            type: NotificationTypes.SUCCESS
          };
          this._notificationsService.openSnackBar(notification);
          this.isLoading = false;

          this._router.navigate([`../customer/${customer.uuid}`], { relativeTo: this._activatedRoute });
        },
        error: error => {
          console.error(error);
          const notification: NotificationModel = {
            message: error.message || `Error creating customer. Please try again.`,
            messages: error.error?.message,
            action: 'Close',
            type: NotificationTypes.ERROR
          };
          this._notificationsService.openSnackBar(notification);
          this.isLoading = false;
        }
      });
  }

  navigateBack() {
    this._router.navigate(['..'], { relativeTo: this._activatedRoute });
  }
}
